export const OSOS_PROVIDERS = {
  GRIDBOX: "Gridbox",
  ENERJISA: "Enerjisa",
  ARIL: "Aril",
};
